import { render, staticRenderFns } from "./ReporteVencidoPieChart.vue?vue&type=template&id=2f16dd2e"
import script from "./ReporteVencidoPieChart.vue?vue&type=script&lang=js"
export * from "./ReporteVencidoPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports